<script setup lang="ts">
    import { InputRow } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';

    defineProps<{
        form: any;
    }>();
</script>

<template>
    <div class="grid grid-cols-1 gap-3">
        <InputRow
            :form="form"
            name="name"
            label="work-calendars.table.name"
        >
            <Input
                id="name"
                v-model="form.name"
                :placeholder="$t('work-calendars.table.name')"
            />
        </InputRow>
    </div>
</template>
